import React from 'react';

import { Box, Button, Typography, useTheme } from '@bcp-nextgen-dx-component-factory/design-system';
import { Link } from '@components';
import { LEFT_PANEL_WIDTH } from '@constants';
import { rem } from '@helpers';

export interface FixedFooterButton {
	text: string;
	onClick: () => void;
	disabled?: boolean;
}

export interface FixedFooterProps {
	leftButton?: FixedFooterButton;
	rightButton: FixedFooterButton;
}

export const FixedFooter: React.FC<FixedFooterProps> = ({ leftButton, rightButton }) => {
	const { colorPalette } = useTheme();

	return (
		<Box
			styles={{
				height: rem(116),
				position: 'fixed',
				bottom: 0,
				alignItems: 'center',
				justifyContent: leftButton ? 'space-between' : 'flex-end',
				width: `calc(100vw - ${rem(LEFT_PANEL_WIDTH)})`,
				zIndex: 100,
				background: colorPalette.color_01[70],
			}}
		>
			{leftButton && (
				<Box styles={{ margin: rem(0, 0, 0, 80) }}>
					<Link onClick={leftButton?.onClick}>
						<Typography appearance="body-100-03" colorToken="interaction-01-100">
							{leftButton?.text}
						</Typography>
					</Link>
				</Box>
			)}
			<Box styles={{ margin: rem(0, 80, 0, 0) }}>
				<Button onPress={rightButton.onClick} disabled={rightButton.disabled}>
					{rightButton.text}
				</Button>
			</Box>
		</Box>
	);
};
